import type { EmailStatus, User } from './user';

export type StripeAccountStatus =
  | 'none'
  | 'can_create_account'
  | 'ok'
  | 'incomplete'
  | 'restricted';

// Order matters: these are rendered as select options, so "pharmacy" appears first and "other" last.
export const pharmacyKinds = [
  'pharmacy',
  'hospital_pharmacy',
  'parapharmacy',
  'medical_equipement_store',
  'sports_store',
  'organic_store',
  'wholesaler',
  'central_purchasing_office',
  'physiotherapist',
  'retirement_home',
  'e_commerce_website',
  'specialized_store',
  'gym',
  'beauty_sport_institute',
  'warehouse',
  'medical_profession_and_similar',
  'other',
] as const;

export type PharmacyKind = (typeof pharmacyKinds)[number];

export interface Pharmacy {
  id: number;
  name: string | null;
  user_id: number | null;
  address_city: string | null;
  address_country: string | null;
  address_line_1: string | null;
  address_zip_code: string | null;
  cip: string | null;
  siren: string | null;
  siret: string | null;
  finess: string | null;
  phone_number: string | null;
  email: string | null;
  verified: boolean;
  is_ambassador: boolean;
  demo_for_lab_id: number | null;
  address_string: string | null;
  uga: string | null;
  sponsored_by_id: number | null;
  created_at: string;
  is_rpps_required: boolean;
  stripe_account_status: StripeAccountStatus;
  stripe_client_id: number | null;
  stripe_account_error: string | null;
  is_open: boolean;
  is_lab_chat_enabled: boolean;
  offisante_acceptance_date: string | null;
  user?: User;
  kind: PharmacyKind;
  old_phone_number: string | null;
  old_cip: string | null;
  is_a_test: boolean;
  default_group_name?: string | null;
  email_verified: boolean;
  email_status: EmailStatus;
  generated_email: string | null;
}

export type PharmacyMinimal = Pick<Pharmacy, 'id' | 'name' | 'cip' | 'address_string'>;
